export function userForm (){

const userFormEl = document.querySelector('.js_user_form')
  if(userFormEl){
    addPlaceholderUserForm()
  }
  function addPlaceholderUserForm(){
    const useFOrmPassInputs = userFormEl.querySelectorAll('.js-form-type-password')
      for (let i = 0; i < useFOrmPassInputs.length; i++) {
      const element = useFOrmPassInputs[i]
        const labelText = element.querySelector('label').textContent
        const pass = element.querySelector('input')
        pass.placeholder = labelText;
    }
  }
}
